var exports = {
  "zr": "AudioWaveform.module__root___enVXY3",
  "Ji": "AudioWaveform.module__canvas___enVXY3",
  "r1": "AudioWaveform.module__selection___enVXY3",
  "EP": "AudioWaveform.module__selectionDragging___enVXY3",
  "p$": "AudioWaveform.module__handle___enVXY3",
  "p_": "AudioWaveform.module__handleStart___enVXY3",
  "es": "AudioWaveform.module__handleEnd___enVXY3",
  "lG": "AudioWaveform.module__playhead___enVXY3",
};

module.exports = exports;
